// used to keep the same reference of the routes object during HMR
import Root from './Root.auth.jsx';
import LoginContainer from '../auth/Login.container.js';
import ResetPasswordContainer from '../auth/ResetPassword.container.js';
import ForgotPasswordContainer from '../auth/ForgotPassword.container.js';
import NotFound from '../NotFound.jsx';

import * as authModule from '../../redux/modules/auth.module';
import * as Api from '../../core/api';

import store from '../../redux/store';

import * as routes from './routes';

export function requireAuth(nextState, replace, callback) {
  Api.auth.getUser()
  .then(({ response }) => {
    if (response.error) {
      replace({
        pathname: routes.auth.prefix + routes.auth.login,
        state: { nextPathname: nextState.location.pathname },
      });
      return callback();
    }
    store.dispatch(authModule.sessionRestored(response));
    return callback();
  })
  .catch(() => {
    replace({
      pathname: routes.auth.prefix + routes.auth.login,
      state: { nextPathname: nextState.location.pathname },
    });
    callback();
  });
}

export function hashLinkScroll() {
  const { hash } = window.location;
  if (hash !== '') {
    // Push onto callback queue so it runs after the DOM is updated,
    // this is required when navigating from a different page so that
    // the element is rendered on the page before trying to getElementById.
    setTimeout(() => {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) element.scrollIntoView();
    }, 0);
  }
}

export default Object.assign({}, {
  path: '/auth',
  indexRoute: { onEnter: (nextState, replace) => replace('/auth/login') },
  childRoutes: [{
    path: routes.auth.prefix,
    component: Root,
    childRoutes: [{
      path: routes.auth.login,
      component: LoginContainer,
    }, {
      path: routes.auth.resetPassword,
      component: ResetPasswordContainer,
    }, {
      path: routes.auth.forgotPassword,
      component: ForgotPasswordContainer,
      onEnter: (nextState, replace) => {
        if (window.location.href.indexOf('?') > -1) {
          store.dispatch(authModule.changeResetTokenExpirationStatus(true));
          replace(routes.auth.prefix + routes.auth.forgotPassword);
        }
      },
    }],
  }, {
    path: '*',
    component: NotFound,
  }],
});



/** WEBPACK FOOTER **
 ** ./js/components/index/routesConfig.auth.js
 **/